import React, { useRef, useEffect } from "react";
import {
  useMount,
  useUnmount,
  useSafeState,
  useUpdateEffect,
  useMap,
  useSize,
  useSetState,
  useTitle,
  useDebounceEffect,
} from "ahooks";
import * as singleSpa from "single-spa";
import { mapAppConfigDatas, menuDatas, sonAppDatas } from "@/config";
import usePathname from "@/hooks/usePathname";
import Page404 from "./Page404";
import SonApp from "./SonApp";
import { BackTop, Spin } from "antd";
import MicroModule from "@/components/MicroModule";
import { customAlphabet } from "nanoid/non-secure";
import useLoginByToken from "./useLoginByToken";
import useSearchJson from "@/hooks/useSearchJson.js";
const cssPrefix = CSS_PREFIX;
const headerId = customAlphabet("abcdefghijklmnopqrstuvwxyz", 20)();
const logsId = customAlphabet("abcdefghijklmnopqrstuvwxyz", 20)();

const getActivitySonApp = (targetPathname = "", list = []) => {
  return list.find((item) => {
    const appBasicPath = item.appBasicPath + "";
    const regStr = String.raw`^${appBasicPath}(/.*)?$`;
    return new RegExp(regStr).test(targetPathname);
  });
};

export default () => {
  const searchJson = useSearchJson();
  const { language = "zh_CN" } = searchJson;
  const pathname = usePathname();
  const [activitySonApp, setactivitySonApp] = useSafeState(
    getActivitySonApp(pathname, sonAppDatas)
  );
  useEffect(() => {
    setactivitySonApp(getActivitySonApp(pathname, sonAppDatas));
  }, [pathname]);
  const [showHeader, setShowHeader] = useSafeState(
    () => !activitySonApp?.hideHeader
  );

  useTitle(activitySonApp?.des);

  useEffect(() => {
    if (activitySonApp) {
      const { hideHeader, children = [] } = activitySonApp;
      setShowHeader(!hideHeader);
      try {
        children.forEach((item) => {
          const regStr = String.raw`^${item.appPathPre}(/.*)?$`;
          if (new RegExp(regStr).test(pathname)) {
            if (item.hideHeader) {
              setShowHeader(false);
            }
          }
        });
      } catch (e) {}
    }
  }, [activitySonApp, pathname]);

  //各子应用引入
  const [sonAppRef, setSonAppRef] = useSetState({});
  const [accountInfo, setAccountInfo] = useSafeState();
  const [organizationInfo, setOrganizationInfo] = useSafeState();

  const getLocalJobInfo = () => {
    let obj = {};
    return obj;
  };
  const [jobInfo, setJobInfo] = useSafeState(getLocalJobInfo);

  const [rtAccountInfo, loadingAccountInfo] = useLoginByToken();
  useEffect(() => {
    const { code, account_info } = rtAccountInfo || {};
    if (code === 1 && account_info) {
      setAccountInfo(account_info);

      const organization_id = window.localStorage.getItem("organization_id");
      if (organization_id) {
        const { joined_organizations = [] } = account_info;
        const org = joined_organizations.find(
          (item) => +item.organization_id === +organization_id
        );
        setOrganizationInfo(org);
        // console.log("默认.org", org, joined_organizations);
      }
    }
  }, [rtAccountInfo]);

  const [headerHeight, setHeaderHeight] = useSafeState(60);
  const noticeSonApp = () => {
    for (const [key, domRef] of Object.entries(sonAppRef)) {
      try {
        domRef?.current?.handleUpdateGlobalConfig?.({
          headerHeight,
          loadingAccountInfo,
          accountInfo,
          organizationInfo,
          jobInfo,
        });
      } catch (e) {
        console.log("e", e);
      }
    }
  };
  useEffect(() => {
    window.eventEmitterGlobal?.removeListener("EeGlobalAccountInfo");
    window.eventEmitterGlobal?.on("EeGlobalAccountInfo", function (params) {
      setAccountInfo(params);
      try {
        const { joined_organizations = [] } = params;
        if (joined_organizations.length === 1) {
          const defOrg = joined_organizations[0];
          const { organization_id } = defOrg;
          window.localStorage.setItem("organization_id", organization_id);
          window.eventEmitterGlobal?.emit("EeGlobalOrganizationInfo", defOrg);
        }
      } catch (e) {
        console.log("异常", e.message);
      }
    });

    window.eventEmitterGlobal?.removeListener("EeGlobalOrganizationInfo");
    window.eventEmitterGlobal?.on(
      "EeGlobalOrganizationInfo",
      function (params) {
        try {
          window.localStorage.setItem(
            "organization_id",
            params.organization_id
          );
        } catch (e) {}
        setOrganizationInfo(params);
      }
    );

    //职位
    window.eventEmitterGlobal?.removeListener("EeGlobaJobInfo");
    window.eventEmitterGlobal?.on("EeGlobaJobInfo", function (params) {
      try {
        window.localStorage.setItem("job_id", params.job_id);
      } catch (e) {}
      setJobInfo(params);
    });

    noticeSonApp();
  }, [sonAppRef]);

  useDebounceEffect(() => {
    noticeSonApp();
  }, [
    accountInfo,
    headerHeight,
    organizationInfo,
    jobInfo,
    loadingAccountInfo,
  ]);

  const refHeader = useRef();
  const sizeHeader = useSize(refHeader);
  useEffect(() => {
    if (sizeHeader) {
      setHeaderHeight(sizeHeader.height);
    }
  }, [sizeHeader]);

  const [isMountLog, setIsMountLog] = useSafeState(false);
  useMount(() => {
    setTimeout(() => {
      setIsMountLog(true);
    }, 1500);
  });

  const { joined_organizations = [] } = accountInfo || {};
  useEffect(() => {
    if (!organizationInfo || !organizationInfo.organization_id) {
      return;
    }
    try {
      let item = joined_organizations.find((item) => {
        return +item.organization_id === +organizationInfo.organization_id;
      });
      if (!item) {
        window.eventEmitterGlobal?.emit("EeGlobalOrganizationInfo", {});
        console.log("组织已不存在");
      }
    } catch (e) {
      console.log("异常啦", e);
    }
  }, [joined_organizations]);

  return (
    <>
      <header
        ref={refHeader}
        id={headerId}
        style={{
          display: showHeader ? "block" : "none",
        }}
      >
        <MicroModule
          datas={menuDatas}
          showType="Default"
          appAssetDir="micro-module/header"
          msMountDomId={headerId}
          onMounted={(domRef) => {
            setSonAppRef({
              header: domRef,
            });
          }}
        />
      </header>

      <div className={`${cssPrefix}`}>
        <SonApp
          activitySonApp={activitySonApp}
          onMounted={(domRef) => {
            if (activitySonApp.id) {
              setSonAppRef({
                [activitySonApp.id]: domRef,
              });
            }
          }}
        />
      </div>

      {sonAppDatas.map((item) => (
        <div
          id={item.id}
          key={item.id}
          data-dir={item.appAssetDir}
          data-des={item.des}
          style={{
            display: item.id === activitySonApp?.id ? "block" : "none",
          }}
        >
          <div className={`${cssPrefix}`} style={{ padding: "1em" }}>
            <Spin spinning={true}>Loading</Spin>
          </div>
        </div>
      ))}
      <div className={`${cssPrefix}`}>
        {!activitySonApp && <Page404 />}
        <BackTop />
      </div>
      {/* <div id={logsId}>
        {isMountLog && (
          <MicroModule
            showType="Default"
            appAssetDir="micro-module/logs"
            msMountDomId={logsId}
            onMounted={(domRef) => {
              setSonAppRef({
                logs: domRef,
              });
            }}
          />
        )}
      </div> */}
    </>
  );
};
